module.exports = __webpack_public_path__ + "static/media/downloadIcon.69aa1d64.svg";